import { render, staticRenderFns } from "./ReservationSiteBadge.vue?vue&type=template&id=218381f3&scoped=true&"
import script from "./ReservationSiteBadge.vue?vue&type=script&lang=js&"
export * from "./ReservationSiteBadge.vue?vue&type=script&lang=js&"
import style0 from "./ReservationSiteBadge.vue?vue&type=style&index=0&id=218381f3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218381f3",
  null
  
)

export default component.exports